/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import { useNavigate } from "react-router";
export const withRouter = (Component) => {
  const Wrapper = (props) => {
    //  
    const history = useNavigate();
    return <Component history={history} {...props} />;
  };
  return Wrapper;
};
